import React, { Component } from "react";
import { Card, CardHeader, CardBody, Row, Col, Table, Badge, Button } from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { MDBDataTableV5, MDBBadge } from "mdbreact";
import moment from "moment";

import {
  getAuditPIRowData,
  AuditPopRight,
  getAuditCQData,
} from "../../store/Audit_Report/actions";

class RequestForQuotationCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: {},
      search: "",
      now: moment(),
      maximize: true,
    };
  }

  componentDidMount() {}

  GetDuraction(startDate, EndDate) {
    var ms = moment(EndDate).diff(moment(startDate));
    var d = moment.duration(ms);
    var mmss = moment.utc(ms).format("mm:ss");
    return Math.floor(d.asHours()) + " Hrs " + mmss + " mm";
  }
  maximizetogle() {
    this.setState((prevState) => ({
      maximize: !prevState.maximize,
    }));
  }
  callNextCard(id) {
    if (this.props.AuditData.length - 1 === this.props.index) {
      this.props.getAuditPIRowData({
        ScreenID: id,
      });
      this.setState((prevState) => ({
        maximize: !prevState.maximize,
      }));
    }
  }
  callNextCQListCard(id) {
    if (this.props.AuditData.length - 1 === this.props.index) {
      this.props.getAuditCQData({
        ScreenID: id,
      });
      this.setState((prevState) => ({
        maximize: !prevState.maximize,
      }));
    }
  }
  render() {
    var obj = {};
    obj = this.props.obj;

    var allitems = [];
    if (obj.data && obj.data.rfqitems) {
      allitems = obj.data.rfqitems.map((row, order) => ({
        ...row,
        sno: (
          <MDBBadge color="primary" className="p-1 px-2">
            {order + 1}
          </MDBBadge>
        ),
        ItemName: (
          <div>
            <h5 className="font-size-14 text-truncate">
              <Link
                to="#"
                onClick={() =>
                  this.callNextCard(
                    row.rfqipiis[row.rfqipiis.length - 1].piitem
                      .purchaseindent_id
                  )
                }
                className="text-primary"
              >
                {/* <i className="mdi  mdi-magnify bg-success text-white"></i>{" "} */}
                <u> {row.product.name}</u>
              </Link>
            </h5>
          </div>
        ),
        IndentQuantity: (
          <span className="font-weight-medium">
            {row.qty} {row.unit.name}
          </span>
        ),
        DateRequired: row.date,
        Department: row.product.department.name,
      }));
    }

    const Itemsdatatable = {
      columns: [
        {
          label: "S.No",
          field: "sno",
          sort: "disabled",
          width: 30,
        },

        {
          label: "Item Name",
          field: "ItemName",

          width: 150,
        },

        {
          label: "Indent Quantity",
          field: "IndentQuantity",

          width: 200,
        },
        {
          label: "Request Date",
          field: "DateRequired",

          width: 150,
        },
        {
          label: "Department",
          field: "Department",

          width: 150,
        },
      ],
      rows: allitems,
    };

    return (
      <div className={this.state.maximize ? "maximize" : "minimize"}>
        <>
          <Row className="plaseholder">
            <Col>
              <Card className="mb-0">
                <CardHeader className="bg-transparent border-bottom ">
                  <h5 className="card-title-18 pt-2 d-inline-block">
                    Request For Quotation <span>(#{obj.data.code})</span>
                  </h5>
                  <div className="float-right">
                    <Button
                      type="button"
                      color="secondary"
                      className="waves-effect waves-light"
                      onClick={() =>
                        this.callNextCQListCard(this.props.obj.data.comparequotations[0])
                      }
                    >
                      Show CQ
                      <i className="ml-2 mdi mdi-arrow-right"></i>
                    </Button>
                  </div>
                </CardHeader>
                <CardBody className="pt-1  ">
                  <Row className="p-1 ">
                    <Col md={12} className="p-1 mb-0">
                      <Card className="p-1 mb-0 mt-0 ">
                        <CardBody className="pt-1 pb-0 mt-0 ">
                          <Row className="p-0">
                            <Col md={8} className="p-1 m-0">
                              <div className="Quotation-panel-content">
                                <div className="list-column">
                                  <Row>
                                    <Col md={6}>
                                      <ul className="list-style-two p-0">
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Request By:
                                          </span>
                                          <span className="dtl">
                                            {obj.data?.createdby?.fullname}
                                          </span>
                                        </li>
                                      </ul>
                                    </Col>
                                    <Col md={6}>
                                      <ul className="list-style-two p-0">
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Submited Date:
                                          </span>
                                          <span className="dtl">
                                            {obj.data.createdon}
                                          </span>
                                        </li>
                                      </ul>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Col>
                            <Col md={4} className="p-0 mt-0"></Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={12} className="p-1">
                      <Card className="p-1">
                        <CardBody className="pt-1 pb-0">
                          <Row>
                            <Col md={12}>
                              <h3 className="card-title-15 pt-2">
                                Vendors List
                              </h3>
                              {/* <hr className="my-4" /> */}
                            </Col>
                          </Row>
                          <Row className="p-0">
                            <Col md={12} className="m-1">
                              <div className="table-responsive mt-2">
                                <Table className="table-centered mb-0">
                                  <thead className="bg-light text-center ">
                                    <tr>
                                      <th style={{ width: "20px" }}>S.No</th>
                                      <th>Vendors Name</th>
                                      <th>Vendors Locations</th>
                                      <th>Vendors Email</th>
                                      <th>Vendor Add On</th>
                                      <th>Running TimeOut</th>
                                      <th>Quotation Status</th>
                                      <th>Quotation View</th>
                                    </tr>
                                  </thead>
                                  <tbody className="text-center">
                                    {obj.data?.rfqvendors !== 0 ? (
                                      <>
                                        {obj.data?.rfqvendors?.map(
                                          (vend, key) => (
                                            <tr>
                                              <td>{key + 1}</td>
                                              <td>{vend.vendor.name}</td>
                                              <td>{vend.vendor.city}</td>
                                              <td>{vend.vendor.email}</td>
                                              <td>
                                                {moment(vend.createdon).format(
                                                  "DD-MM-YYYY, h:mm:ss"
                                                )}
                                              </td>
                                              <td>
                                                {vend.loginstatus !== 2 ? (
                                                  <>
                                                    {moment
                                                      .duration(
                                                        moment().diff(
                                                          moment(vend.createdon)
                                                        )
                                                      )
                                                      .asHours() >=
                                                    obj.data.hr ? (
                                                      <>
                                                        <Badge
                                                          color="danger"
                                                          className="font-size-14"
                                                        >
                                                          Time Expired
                                                        </Badge>
                                                      </>
                                                    ) : (
                                                      <Badge
                                                        color="info"
                                                        className="font-size-14"
                                                      >
                                                        {" "}
                                                        {this.GetDuraction(
                                                          vend.createdon,
                                                          this.state.now
                                                        )}
                                                      </Badge>
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    <Badge
                                                      color="success"
                                                      className="font-size-14"
                                                    >
                                                      {" "}
                                                      {this.GetDuraction(
                                                        vend.createdon,
                                                        vend.quotation_createdon
                                                      )}
                                                    </Badge>
                                                  </>
                                                )}
                                              </td>
                                              <td>
                                                {vend.resend === true ? (
                                                  <Badge
                                                    color="pink"
                                                    className="font-size-14 "
                                                  >
                                                    Reset
                                                    {/* <i className="mdi mdi-clipboard-text font-size-18 "></i> */}
                                                  </Badge>
                                                ) : (
                                                  <></>
                                                )}
                                              </td>
                                              <td>
                                                {vend.loginstatus === 2 ? (
                                                  <>
                                                    <Badge
                                                      color="primary"
                                                      className="font-size-14"
                                                    >
                                                      Submited
                                                      {/* <i className="mdi mdi-clipboard-text font-size-18 "></i> */}
                                                    </Badge>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Badge
                                                      color="primary"
                                                      className="font-size-14"
                                                    >
                                                      Not Submited
                                                    </Badge>
                                                  </>
                                                )}
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </>
                                    ) : (
                                      <tr>
                                        <td colSpan={6}>
                                          <div className="text-center">
                                            <span className="font-size-18 text-danger">
                                              Vendors not available
                                            </span>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md={12} className="p-1">
                      <Card className="p-1">
                        <CardBody className="pt-1 pb-0">
                          <Row>
                            <Col md={12}>
                              <h3 className="card-title-15 pt-2">Items List</h3>
                              {/* <hr className="my-4" /> */}
                            </Col>
                          </Row>
                          <Row className="p-0">
                            <Col md={12} className="m-1">
                              <MDBDataTableV5
                                hover
                                maxHeight="100px"
                                responsive
                                striped
                                entriesOptions={[5, 20, 25]}
                                entries={5}
                                pagesAmount={4}
                                fullPagination
                                data={Itemsdatatable}
                                searchBottom={false}
                              />
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Link
            to="#"
            className="strip"
            onClick={() => {
              this.maximizetogle();
              this.props.AuditPopRight(this.props.index);
            }}
          >
            <div className="MaximizeCard-item mb-2 ">
              <div className="MaximizeCard-title-box d-inline-block">
                <span className="mt-4">
                  Request For Quotation ({obj.data.code})
                </span>
              </div>
            </div>
          </Link>
        </>
      </div>
    );
  }
}

const mapStatetoProps = (state) => {
  const { AuditData } = state.AuditReport;

  return {
    AuditData,
  };
};

export default connect(mapStatetoProps, {
  getAuditPIRowData,
  AuditPopRight,
  getAuditCQData,
})(RequestForQuotationCard);
